import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { WhyGoldspeakers } from './components/WhyGoldspeakers';
import { HowItWorks } from './components/HowItWorks';
import { WhatYouGet } from './components/WhatYouGet';
import { SpeakerProfiles } from './components/SpeakerProfiles';
import { WhoWeWorkWith } from './components/WhoWeWorkWith';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream-50 font-body text-gray-600 selection:bg-gold-200 selection:text-navy-900" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <WhyGoldspeakers data-id="element-4" />
        <HowItWorks data-id="element-5" />
        <WhatYouGet data-id="element-6" />
        <SpeakerProfiles data-id="element-7" />
        <WhoWeWorkWith data-id="element-8" />
        <FinalCTA data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}